import { useEffect, useState } from "react";
import { useRouter } from "src/routes/hooks";
import { SplashScreen } from "src/components/loading-screen";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

type AuthGuardProps = {
  children: React.ReactNode;
};

export function AuthGuard({ children }: AuthGuardProps) {
  const router = useRouter();
  const { token, loading } = useSelector((state: RootState) => state.auth);
  const [isChecking, setIsChecking] = useState<boolean>(true);

  const checkTokenAndRedirect = () => {
    const storedToken = localStorage.getItem("token");
    if (!storedToken) {
      router.replace("/login");
    } else {
      setIsChecking(false);
    }
  };

  useEffect(() => {
    if (!loading) {
      checkTokenAndRedirect();
    }
  }, [loading]);

  useEffect(() => {
    const handleStorage = (event: StorageEvent) => {
      if (event.key === "token" && event.newValue === null) {
        router.replace("/login");
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  if (isChecking) {
    return <SplashScreen />;
  }

  return <>{children}</>;
}
